export default __webpack_public_path__ + "static/media/no_gods_no_master.3d780052.mp3";